var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameFieldIconAb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6248_83259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4893 47.6626V44.573C44.4893 39.4543 39.7463 35.3044 33.8959 35.3044H25.4232C19.5729 35.3044 14.8298 39.4543 14.8298 44.573V47.6626M37.0745 20.4747C37.0745 22.4412 36.2933 24.3272 34.9027 25.7178C33.5121 27.1084 31.6261 27.8896 29.6596 27.8896C27.693 27.8896 25.807 27.1084 24.4165 25.7178C23.0259 24.3272 22.2447 22.4412 22.2447 20.4747C22.2447 18.5081 23.0259 16.6221 24.4165 15.2316C25.807 13.841 27.693 13.0598 29.6596 13.0598C31.6261 13.0598 33.5121 13.841 34.9027 15.2316C36.2933 16.6221 37.0745 18.5081 37.0745 20.4747Z",
    stroke: "white",
    strokeWidth: 3.9546,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6248_83259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.319,
    height: 59.319,
    fill: "white",
    transform: "translate(0 0.701904)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameFieldIconAb);
export default __webpack_public_path__ + "static/media/nameFieldIcon_ab.bb8b1f8e83f5b4dccb44bf65e087e475.svg";
export { ForwardRef as ReactComponent };